import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { emailRegExp } from '../../../../utils/utilityEtc';

function EmailInput({
  email,
  onChangeEmail,
  onResetEmail
}) {
  const { t } = useTranslation();
  const [emailCheck, setEmailCheck] = useState('');
  
  const onBlur = useCallback(() => {
    if (!email) return;
    // 이메일 양식이 맞으면  true 아니면 false;
    const result = emailRegExp(email);
    setEmailCheck(result ? 'success' : 'fail');
  }, [email]);

  return (
    <>
      <div className="input_box white_box">
        <input 
          type="text"
          placeholder={t("MY_02_05.msg003")}
          value={email}
          onBlur={onBlur}
          onChange={onChangeEmail}
        />
        {
          emailCheck && (
            <div className="r_area">
              {
                emailCheck === 'fail'
                  ? <button type="button" onClick={onResetEmail}><img src="./static/images/icon/ic_error.svg" alt=""/></button>
                  : <img src="./static/images/icon/ic_check.svg" alt="" />
              }
            </div>
          )
        }
      </div>
      {emailCheck === 'fail' && <div className="red_txt fs12_10">{t("MY_02_05.msg031")}</div>}
    </>
  );
}

export default EmailInput;